<template lang="">
    <div class="p-4 border border-gray-500 rounded-2xl flex flex-col gap-y-4 max-w-[390px] w-full"
        :class="{
            'border-red-500': uploadExecution.error,
            'border-success': uploadExecution.success,
        }">
        <InputSelectDisabled title="Sold" :placeholder="uploadExecution.store.name" />

        <div>
            <InputSelectDisabled title="Campanha" :placeholder="uploadExecution.campaign.name" />
            <label v-if="enableSendNespoints"
                class="flex items-center self-center mt-1 gap-x-2 text-primary"
            >
                <input type="checkbox" class="cursor-pointer" v-model="uploadExecution.sendToNespoint" />
                <p>Enviar para Nespoints</p>
            </label>
        </div>
        <InputSelectDisabled title="Execução" :placeholder="uploadExecution.execution.name" />
        <div>
            <p class="font-bold">Sub-categorias</p>
            <div class="flex flex-col w-full border border-gray-500 bg-white rounded-2xl mt-2 pointer-events-none">
                <label class="flex items-center gap-x-2 p-2 border-t first:border-t-0 border-gray-500" v-for="(option) in uploadExecution.categories" :key="option.id">
                    <input disabled type="checkbox" checked>
                    <p>{{option.name}}</p>
                </label>
            </div>
        </div>
        <!-- <InputSelectDisabled title="Sub-categoria" :placeholder="uploadExecution.category.name" /> -->
        <div class="max-w-[370px]">
            <p class="font-bold">Suba suas fotos</p>
            <Splide :options="{ rewind: true }" aria-label="My Favorite Images">
                <SplideSlide v-for="(file, key) in uploadExecution.files" :key="key">
                    <div 
                        class="w-full border rounded-xl p-4 mt-4 pb-9"
                        :class="{
                            'border-error': file.fileStatus.status == 'error',
                            'border-success': file.fileStatus.status != 'error' && !file.fileStatus.hashAlreadyExistsInFormList,
                            'border-yellow': file.fileStatus.hashAlreadyExistsInFormList,
                        }"
                    >
                        <div
                            class="transition-all w-full h-[200px] flex justify-center items-center border rounded-xl border-dashed border-black bg-gray-200 hover:bg-gray-300 hover:text-blue-600 text-sm hover:underline cursor-pointer"
                        >
                            <img class="object-contain w-full h-[200px] rounded-xl" :src="file.src" />
                        </div>
                        <div class="flex items-center justify-between mt-4">
                            <div>
                                <p class="text-xs">
                                    {{file.name}}
                                </p>
                            </div>
                        </div>
                    </div>
                </SplideSlide>
            </Splide>
        </div>
        <div>
            <p class="font-bold">Equipe</p>
            <div class="flex flex-col w-full border border-gray-500 bg-white rounded-2xl mt-2 pointer-events-none">
                <label class="flex items-center gap-x-2 p-2 border-t first:border-t-0 border-gray-500" v-for="(option) in uploadExecution.team" :key="option.id">
                    <input disabled type="checkbox" checked>
                    <p>{{option.user?.name}}</p>
                </label>
            </div>
        </div>
        <div class="flex gap-x-8 pt-8 pb-4 justify-center">
            <button @click.prevent="$emit('onRemove', true)"
                class="
                    px-4
                    py-2
                    bg-white
                    border
                    border-primary
                    rounded-full
                    font-bold
                    text-primary
                    hover:bg-gray-300
                    hover:border-gray-300
                ">
                <div>
                    Excluir
                </div>
            </button>
            <button v-if="!uploadExecution.success"
                @click.prevent="$emit('onEdit', true)"
                class="
                    px-4
                    py-2
                    bg-primary
                    rounded-full
                    font-bold
                    text-white
                    hover:bg-highlight
                ">
                <div>
                    Editar
                </div>
            </button>
        </div>
    </div>
</template>
<script>
import InputSelectDisabled from "@/Components/UI/Form/InputSelectDisabled.vue"
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import Button from "@/Components/Button.vue";

export default {

    emits: ['onEdit', 'onRemove'],
    components: {
        InputSelectDisabled,
        Splide,
        SplideSlide,
        Button
    },
    props: {
        uploadExecution: Object,
        enableSendNespoints: Object,
    },
    computed: {
        slidesLenght() {
            return (this.uploadExecution.files.length * 25) + 'px';
        }
    }
}
</script>
<style>
    .splide__arrow {
        background-color: white;
        transform: translateY(-35px);
        border: 2px solid #0771c5;
        opacity: 100%;
    }

    .splide__arrow--prev{
        left: 6px;
    }

    .splide__arrow--next{
        right: 6px;
    }

    .splide__arrow svg{
        fill: #0771c5;
    }

    .splide__pagination {
        column-gap: 7px;
        padding: 4px;
        background: #0771c5;
        bottom: 0px;
        max-width: v-bind(slidesLenght);;
        margin-left: auto;
        margin-right: auto;
        transform: translateY(-50%);
        left: 0;
        right: 0;
        border-radius: 30px;
    }

    .splide__pagination li {
        display: flex;
    }

    .splide__pagination__page.is-active {
        background-color: white;
    }

    .splide__pagination__page {
        transform: scale(1.4);
        background-color: #142950;
    }

    /* r Chrome, Safari and Opera */
    .no-scroll-bar::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    .no-scroll-bar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
</style>
